import { render, staticRenderFns } from "./picSwipe.vue?vue&type=template&id=2a57462a&scoped=true&"
import script from "./picSwipe.vue?vue&type=script&lang=js&"
export * from "./picSwipe.vue?vue&type=script&lang=js&"
import style0 from "./picSwipe.vue?vue&type=style&index=0&id=2a57462a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a57462a",
  null
  
)

export default component.exports